import { bootstrapApplication } from '@angular/platform-browser';
import { hydrateFromPeers, purgeLegacyTokenBlob } from '@branduals/auth-storage';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

// Pre-bootstrap window — the OIDC library reads its storage synchronously during service
// construction, so both steps below must complete before Angular bootstraps:
//
// 1. Purge the LEGACY localStorage token blob unconditionally. Tokens live in a
//    memory+sessionStorage partition now; anything under the old keys is debris from the
//    pre-partition storage, and the first new-code load deletes it for the whole origin.
//    (The old issuer-mismatch check existed only to bust this cache — retired with it.)
// 2. Ask peer tabs for their in-memory tokens (bounded ~50 ms) so a second tab signs in
//    without a round-trip. No peer answer ⇒ genuinely cold.
purgeLegacyTokenBlob();

hydrateFromPeers()
  .then(() => bootstrapApplication(AppComponent, appConfig))
  .catch((err) => console.error(err));
